import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function RegionIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <g clipPath="url(#clip0_4_13)">
        <path
          d="M23.5 1H8.5C4.35786 1 1 4.35786 1 8.5V23.5C1 27.6421 4.35786 31 8.5 31H23.5C27.6421 31 31 27.6421 31 23.5V8.5C31 4.35786 27.6421 1 23.5 1Z"
          fill="url(#paint0_linear_4_13)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.4744 18.8242L25.0042 25H20.0269C19.5467 25 19.109 24.7251 18.9005 24.2926L16.8883 20.1172L14.2108 14.9297H19.1186C19.4341 14.9297 19.5771 14.8642 19.8894 14.5682C20.1198 14.3497 20.1962 13.61 20.1962 13.1364C20.1962 12.6627 19.7925 12.1759 19.5556 11.9737C19.3186 11.7715 18.6985 11.6733 18.3831 11.6733H12.8307L11.9667 9.73533C11.8467 9.46623 11.6355 9.24816 11.3704 9.11956L7 7H17.0239C19.2237 7 20.9927 7.61925 22.3313 8.85774C23.6783 10.0879 24.352 11.6569 24.352 13.5649C24.352 14.2678 24.2497 14.9289 24.045 15.5481C23.8489 16.159 23.6102 16.6569 23.3288 17.0419C23.0474 17.4268 22.7662 17.7615 22.4848 18.046C22.212 18.3306 21.9775 18.5314 21.7813 18.6486L21.4744 18.8242ZM15.1837 25L13.1256 20.6625C12.9601 20.3134 12.6083 20.0909 12.2219 20.0909H10.1594C9.43981 20.0909 8.95565 20.8277 9.2414 21.488L10.5004 24.3971C10.6588 24.7631 11.0196 25 11.4184 25H15.1837Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4_13"
          x1="1"
          y1="16"
          x2="31"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E63F3F" />
          <stop offset="1" stopColor="#AB2929" />
        </linearGradient>
        <clipPath id="clip0_4_13">
          <rect width="30" height="30" fill="white" transform="translate(1 1)" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
}
